<template>
    <div>
        <BasicNavigation header-image="header_wahana.png"></BasicNavigation>
        <v-container grid-list-md text-xs-center>
            <v-layout row align-center justify-center wrap>
                <h1>Special Feature</h1>
            </v-layout>
        </v-container>
        <v-container grid-list-md text-xs-center>
            <v-layout row align-center justify-center wrap>
                <v-flex xs10 sm8 md3 lg3 xl3>
                    <v-card class="rounded-card">
                        <v-img
                                src="/images/special_feature_head1.png"
                                aspect-ratio="1"
                        ></v-img>
                        <v-card-title primary-title>
                            <div>221 mentor siap membimbing dan memberikan laporan aktifitas.</div>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs10 sm8 md3 lg3 xl3>
                    <v-card class="rounded-card">
                        <v-img
                                src="/images/special_feature_head2.png"
                                aspect-ratio="1"
                        ></v-img>
                        <v-card-title primary-title>
                            <div>
                                Laporan aktivitas bermain dengan 4 variabel bentuk kecerdasan anak.
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs10 sm8 md3 lg3 xl3>
                    <v-card class="rounded-card">
                        <v-img
                                src="/images/special_feature_head3.png"
                                aspect-ratio="1"
                        ></v-img>
                        <v-card-title primary-title>
                            <div>
                                Kesempatan orang tua untuk konsultasi mengenai minat dan bakat anak.
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-container grid-list-md text-xs-center my-2>
                <v-layout row align-center justify-center wrap>
                    <h1>Playground</h1>
                </v-layout>
            </v-container>
            <v-container grid-list-md text-xs-center>
                <v-layout row align-center justify-center wrap>
                    <v-flex xs12 sm12 md6>
                        Skema permainan dirancang sistematis dengan rangkaian fungsi organ lembaga sosial dalam pemenuhan kebutuhan pemain dan keteraturan aktivitas bermain.
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container fluid grid-list-md>
                <v-data-iterator
                        :items="itemsWahana"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="pagination"
                        content-tag="v-layout"
                        row
                        wrap
                >
                    <template v-slot:item="props">
                        <v-flex xs12 sm6 md4 lg3>
                            <v-card class="rounded-card">
                                <v-img :src="props.item.profile_picture"
                                        aspect-ratio="1.5"
                                ></v-img>
                                <v-card-title primary-title>
                                    <h1 style="margin-bottom: 5px;">{{ props.item.name }}</h1>
                                    <div style="text-align: justify;" v-html="props.item.info"></div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                    </template>
                </v-data-iterator>
            </v-container>

            <v-container grid-list-md text-xs-center my-2>
                <v-layout row align-center justify-center wrap>
                    <h1>Infotainment MAPS</h1>
                </v-layout>
            </v-container>
            <v-container grid-list-md text-xs-center my-2>
                <v-layout row align-center justify-center wrap>
                    <img src="/images/maps.png">
                </v-layout>
            </v-container>
            <v-container grid-list-md text-xs-center my-5>
                <v-layout row align-center justify-center wrap>
                    <h1>Champion School Area</h1>
                    <h2>4-15 Years Old</h2>
                </v-layout>
            </v-container>
            <v-container grid-list-md text-xs-center my-2>
                <v-layout row align-center justify-center wrap>
                    <img src="/images/wahanalist.png" width="100%">
                </v-layout>
            </v-container>
        </v-container>
    </div>
</template>

<style scoped>

</style>

<script>
    import HomeAPI from "@/api/home";
    import BasicNavigation from "@/components/BasicNavigation";

    export default {
        name: 'wahana',
        components: {
            BasicNavigation
        },
        data() {
            return {
                itemsWahana: [],
                rowsPerPageItems: [4, 8, 12],
                pagination: {
                    rowsPerPage: 4
                },
            }
        },
        mounted: function(){
            HomeAPI.getWahana().then(response => {
                this.itemsWahana = response.data.results.data;
            });
        }
    }
</script>